export class User {

  constructor(
    public id: number,
    public name: string,
    public type: string,
    public TRDR: string,
    public isAdmin: boolean,
    private _token: string,
  ) { }


  get token() {
    return this._token;
  }

}
